<template>
<div class="container mt-3">
  <div
    v-if="selectedRoom"
    class="position-absolute top-0 end-0 m-3 bg-dark bg-opacity-75 px-3 py-2 rounded shadow"
    style="z-index: 1000;"
  >
    <h4>Current Room：{{ selectedRoom }}</h4>
    <div class="d-inline-flex align-items-center">
      <button
        class="btn btn-outline-light btn-sm me-2"
        @click="swapCamera"
      >
        <i class="bi bi-arrow-repeat"></i>
       </button>
     </div>

     <div class="position-relative d-inline-block">
       <div class="d-inline-flex align-items-center border rounded px-2 bg-dark">
         <button class="btn btn-sm p-0 me-2 text-light bg-transparent border-0" @click="toggleVolumeBar">
           <i class="bi bi-volume-up"></i>
         </button>

         <select
           class="form-select form-select-sm border-0 shadow-none bg-secondary text-white"
           style="width: 80px;"
           v-model="selectedAudio"
           @change="handleAudioChange"
         >
           <option v-for="option in audioOptions" :key="option" :value="option">
             {{ option }}
           </option>
         </select>
       </div>
       <div
         class="position-absolute bg-dark border rounded mt-1 px-2"
           v-if="showVolumeBar"
           style="z-index: 1000; width: 120px;"
         >
         <div class="d-flex align-items-center">
           <input
             type="range"
             class="form-range me-2"
             min="0"
             max="100"
             v-model="volume"
             style="width: 100px;"
           />
         </div>
       </div>
     </div>
  </div>

  <div class="row g-3 justify-content-center">
    <div
      v-if="userIds.length > 0"
      :key="userIds[0]"
      class="col-12 d-flex justify-content-center"
    >
      <span
        class="position-absolute top-1 right-1 bg-black bg-opacity-50 text-xs px-2 py-1 rounded text-white"
        :id="`user-status-${userIds[0]}`"
      >
      </span>

      <video
        :id="`video-${userIds[0]}`"
        class="border rounded shadow"
        width="640"
        height="480"
        autoplay
        muted
        playsinline
      ></video>
    </div>

    <div class="col-12 d-flex justify-content-center gap-3">
      <div
        v-for="id in userIds.slice(1)"
        :key="id"
        class="mx-2"
      >
        <span
          class="position-absolute top-1 right-1 bg-black bg-opacity-50 text-xs px-2 py-1 rounded text-white"
          :id="`user-status-${id}`"
        >
        </span>

        <video
          :id="`video-${id}`"
          class="border rounded shadow"
          width="320"
          height="180"
          autoplay
          muted
          playsinline
        ></video>
      </div>
    </div>

  </div>
    <div v-if="showModal" class="modal d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.2);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark text-light border-secondary">
          <div class="modal-header">
            <h5 class="modal-title">Choose Your Room</h5>
            <button type="button" class="btn-close btn-close-white" aria-label="Close" @click="showModal = false"></button>
          </div>
          <div class="modal-body">

            <div class="row align-items-center mb-2">
              <div class="col-auto">
                <label for="inputP1" class="col-form-label">P1:</label>
              </div>
              <div class="col">
                <input type="text" class="form-control bg-secondary text-white" id="inputP1" v-model="p1Id">
              </div>
            </div>

            <div class="row align-items-center mb-3">
              <div class="col-auto">
                <label for="linkedP2" class="col-form-label da">P2:</label>
              </div>
              <div class="col">
                <input type="text" class="form-control bg-secondary text-white" id="linkedP2" v-model="p2Id">
              </div>
            </div>

            <ul class="list-group">
              <li
                v-for="room in roomIds"
                :key="room"
                class="list-group-item list-group-item list-group-item-action"
                @click="selectRoom(room)"
                style="cursor: pointer;"
              >
                {{ room }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, computed } from 'vue'
import { useRoute } from 'vue-router'
import AgoraRTC from 'agora-rtc-sdk-ng';

const route = useRoute()
const spectatorId = ref('')
spectatorId.value = 1008
const roomIds = ref([])
const selectedRoom = ref('')
const showModal = ref(false)
const apiUrl = ref('')
const userIds = ref([])
const userAlias = ref(['3rd', 'P1', 'P2'])
const { appContext } = getCurrentInstance();
const APP_ID = ref("");
const showVolumeBar = ref(false);
const audioOptions = ref(['OFF']);
const selectedAudio = ref(audioOptions.value[0]);
const audiotrackMap = ref({});
const p1Id = ref('');
const p2Id = ref('');

const volume  = computed({
  get: () => {
    const selectedAudioTrack = audiotrackMap.value[selectedAudio.value]
    if (selectedAudioTrack) {
      return selectedAudioTrack.volume;
    } else {
      return 0;
    }
  },
  set: (newVolume) => {
    const selectedAudioTrack = audiotrackMap.value[selectedAudio.value]
    if (selectedAudioTrack) {
      selectedAudioTrack.volume = newVolume;
      selectedAudioTrack.track.setVolume(newVolume);
    }
  }
});

const toggleVolumeBar = () => {
  showVolumeBar.value = !showVolumeBar.value;
}

const handleAudioChange = () => {

  // loop audiotack map to stop
  for (const key in audiotrackMap.value) {
    const audioTrack = audiotrackMap.value[key].track;
    if (audioTrack) {
      audioTrack.stop();
    }
  }

  // start the selected audio track
  const selectedAudioTrack = audiotrackMap.value[selectedAudio.value]
  if (selectedAudioTrack) {
    selectedAudioTrack.track.play();
  }
};

APP_ID.value = appContext.config.globalProperties.$APP_ID;

onMounted(() => {
  const rawRooms = route.query.roomId || ''
  roomIds.value = typeof rawRooms === 'string' ? rawRooms.split(',') : rawRooms

  if (roomIds.value.length === 1) {
    selectedRoom.value = roomIds.value[0]
  } else if (roomIds.value.length > 1) {
    showModal.value = true
  }
})

function swapCamera() {

  for (let i = 0; i < userIds.value.length - 1; i++) {

    let currVidEl = document.getElementById('video-' + userIds.value[i]);
    let nextVidEl = document.getElementById('video-' + userIds.value[i + 1]);
    let currSrc = currVidEl.srcObject;
    let nextSrc = nextVidEl.srcObject;
    currVidEl.srcObject = nextSrc;
    nextVidEl.srcObject = currSrc;
    currVidEl.id = 'video-' + userIds.value[i + 1];
    nextVidEl.id = 'video-' + userIds.value[i];

    let currStatusEl = document.getElementById('user-status-' + userIds.value[i]);
    let nextStatusEl = document.getElementById('user-status-' + userIds.value[i + 1]);
    let currStatus = currStatusEl.innerText;
    let nextStatus = nextStatusEl.innerText;
    currStatusEl.innerText = nextStatus;
    nextStatusEl.innerText = currStatus;
    let currClass = currStatusEl.className;
    let nextClass = nextStatusEl.className;
    currStatusEl.className = nextClass;
    nextStatusEl.className = currClass;
    currStatusEl.id = 'user-status-' + userIds.value[i + 1];
    nextStatusEl.id = 'user-status-' + userIds.value[i];
  }
}

function selectRoom(room) {
  selectedRoom.value = room
  showModal.value = false
  console.log('Selected room:', room)

  userIds.value = [1000, 1000 + parseInt(p1Id.value), 1000 + parseInt(p2Id.value)]
  const secretId = appContext.config.globalProperties.$USER.secretId;
  const secretKey = appContext.config.globalProperties.$USER.secretKey;
  apiUrl.value = '/api/room/' + room + '?secret_id=' + secretId + '&secret_key=' + secretKey + '&user_id=' + spectatorId.value;
  startStream()
}

async function startStream() {
  const token = await fetch(apiUrl.value).then(data => data.json())
  if (token === undefined) {
    return;
  }

  const rtcToken = token.rtc_token;
  const appId = APP_ID.value;
  const channel = selectedRoom.value;

  var rtcClient = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
  rtcClient.on("user-published", async (user, mediaType) => {
    console.log("user-published: ", user, mediaType);
  });

  rtcClient.on('connection-state-change', async (curState, revState, reason) => {
    console.log('connection-state-change: ' + curState, revState, reason);

    if (curState == 'CONNECTED') {
      for (let i = 0; i < userIds.value.length; i++) {
        const statusEl = document.getElementById('user-status-' + userIds.value[i]);
        if (statusEl) {
          statusEl.innerText = userAlias.value[i];
        }
      }
    }

    if (reason == 'UID_BANNED') {
      alert('Another tab is logged in with the same UID, please close the other tab');
    }
  });

  rtcClient.on('user-joined', async (user) => {
    const el = document.getElementById('user-status-' + (user.uid + 1000));
    if (el) {
      el.className = 'position-absolute top-1 right-1 bg-black bg-opacity-50 text-xs px-2 py-1 rounded text-danger';
    }
  });

  rtcClient.on('user-left', async (user) => {
    const el = document.getElementById('user-status-' + (user.uid + 1000));
    if (el) {
      el.className = 'position-absolute top-1 right-1 bg-black bg-opacity-50 text-xs px-2 py-1 rounded text-white';
    }
  });

  rtcClient.on("user-published", async (user, mediaType) => {
    for (let i = 0; i < userIds.value.length; i++) {
      if (user.uid == userIds.value[i]) {
        await rtcClient.subscribe(user, mediaType);
        console.log("video track subscribed: ", user.uid);
        user.videoTrack.play('video-' + user.uid);
      }

      const audioUid = parseInt(userIds.value[i]) + 100000;
      if (user.uid == audioUid) {
        await rtcClient.subscribe(user, mediaType);
        console.log("audio user-published: ", user.uid);
        audioOptions.value.push(userAlias.value[i]);
        audiotrackMap.value[userAlias.value[i]] = {'track': user.audioTrack, 'volume': 100};
      }
    }
  });

  rtcClient.on("token-privilege-will-expire", async () => {
    console.log("Token will expire, requesting a new token...");
    const token = await fetch(apiUrl.value).then(data => data.json())
    if (token !== undefined) {
      const rtcToken = token.rtc_token;
      await rtcClient.renewToken(rtcToken);
    }
  });

  const uid = await rtcClient.join(appId, channel, rtcToken, spectatorId.value);
  console.log("uid: ", uid);
}
</script>
